import { unitConstants } from '../constants/mathConstant.js';

// Values arrive straight from the API, where a numeric field can still be a string.
type ProductWeight = {
  value?: number | string | null;
  unit?: string | null;
};

type ContentsEntry = {
  weight?: ProductWeight | null;
  qty?: number | string | null;
};

// Weight of a single SKU, in pounds. Each SKU carries its own unit, so one package can mix SKUs
// recorded in kilograms with SKUs recorded in pounds; converting the summed total instead of each
// line would silently scale the whole package by whichever unit happened to come first.
export const productWeightInPounds = (weight?: ProductWeight | null): number => {
  const value = Number(weight?.value) || 0;
  return weight?.unit === 'kg' ? value * unitConstants.KiloInlb : value;
};

// Weight of the package contents, in pounds. Contents only: the API adds the packaging material
// tare on top of what we send, so including it here would double-count it, and substituting it for
// the item weight would drop the contents entirely.
export const sumContentsWeightInPounds = (entries?: ContentsEntry[] | null): number =>
  (entries || []).reduce((total, entry) => {
    const qty = Number(entry?.qty ?? 1) || 0;
    return total + productWeightInPounds(entry?.weight) * qty;
  }, 0);
